"use strict";
exports.getWeekOfMonth = getWeekOfMonth;
var _index = require("./getDate.js");
var _index2 = require("./getDay.js");
var _index3 = require("./startOfMonth.js");
var _index4 = require("./_lib/defaultOptions.js");
function getWeekOfMonth(date, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const defaultOptions = (0, _index4.getDefaultOptions)();
  const weekStartsOn = (_h = (_g = (_d = (_c = options == null ? void 0 : options.weekStartsOn) != null ? _c : (_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.weekStartsOn) != null ? _d : defaultOptions.weekStartsOn) != null ? _g : (_f = (_e = defaultOptions.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.weekStartsOn) != null ? _h : 0;
  const currentDayOfMonth = (0, _index.getDate)(date);
  if (isNaN(currentDayOfMonth)) return NaN;
  const startWeekDay = (0, _index2.getDay)((0, _index3.startOfMonth)(date));
  let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
  const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}
